import {useEffect, useState} from 'react';
import useTimeout from "./useTimeout";

export default (pollFunc, interval, shouldPoll) => {
    const [pollingStarted, triggerPolling] = useState(false);

    useTimeout(pollFunc, (shouldPoll && pollingStarted) ? interval : null);

    useEffect(() => {
        pollFunc(0);
        triggerPolling(true);
    }, [pollFunc, triggerPolling]);
}
